"use strict";

module.exports = {
  publicPath: "./",
  pathPrefix: "/student/2021/toda/", //default: process.env.BASE_URL,
  title: "戸田の卒研サイト",
  googleAnalyticsId: "UA-158329895-2",
  footerMsg: "Physics Laboratory <sup>2021</sup>",
  author: {
    name: "戸田",
    bio: "大学生",
    contacts: {
      github: "masa-dev",
      twitter: "masa_devpro",
      mail: "1810990019g@hiro.kindai.ac.jp",
    },
  },
  OpenMdFileWhenCreated: true,
};
